export default __webpack_public_path__ + "static/media/background.f5c49a0d.jpg";